export { default } from './SearchInputCDS';
